import CardWithCta from './card-with-cta';

export default CardWithCta;
